import React, { useEffect, useState } from "react";
import Text from "antd/lib/typography/Text";
import { Button, Image, Progress } from "antd";
import styles from "../../styles/dashboard.module.scss";
import BarChart from "../../components/StackedBar";
import StackedBarWellness from "../../components/StackedBarWellness";
import { authSVC } from "../../services";
import moment from "moment";
import { useB2BContext } from "../../context/ContextB2B";

export default function WellnessBarchart({ year }: any) {
  const { getUserByID } = useB2BContext();

  const [yearlyDepartmentIndexes, setYearlyDepartmentIndexes] = useState<any>();

  useEffect(() => {
    // const year: any = moment().format("yyyy");
    if (getUserByID) {
      authSVC
        .yearlyDepartmentIndexes({
          reportFor: "wellness",
        })
        .then((res: any) => {
          setYearlyDepartmentIndexes(res?.data?.data);
          console.log(res.data.data, "yearlyDepartmentIndexes");
        })
        .catch((err: any) => {
          //message.error(err.response?.data?.error);
        });
console.log(getUserByID,"getUserByID");

      authSVC
        .yearlyWellnessIndexes({
          year: year,
          department: "",
          company: getUserByID?.company,
        })
        .then((res: any) => {
          // setYearlyDepartmentIndexes(res?.data?.data);
          console.log(res.data.data, "yearlyWellnessIndexes");
        })
        .catch((err: any) => {
          //message.error(err.response?.data?.error);
        });
    }
  }, [getUserByID]);

  return (
    <div className={styles.white_bg_wrapper}>
      <div className={styles.info_title}>
        <div className="overview-card__header">
          <div className="overview-card__title-row">
            <span
              className="overview-card__dot"
              style={{ background: "#5bbcb0" }}
            />
            <h3 className="overview-card__title">Wellness Index</h3>
          </div>
          <div className="overview-card__trend">
            <Image src="/figma/up_arrow.svg" preview={false} width={14} />
            <span>{yearlyDepartmentIndexes?.percentage}% from last month</span>
          </div>
        </div>
        <div className={styles.graph}>
          {yearlyDepartmentIndexes?.series.length === 0 ? (
            <div className="no_data_yet">
              <img src="/img/User_empty.png" alt="" width="56" height="52" />
              <p>No data yet</p>
            </div>
          ) : (
            <StackedBarWellness chartData={yearlyDepartmentIndexes} />
          )}
        </div>
      </div>
    </div>
  );
}
